import styled from 'styled-components'
import Text from './Text'

const TextSecondary = styled(Text)`
  color: ${({ theme }) =>
    theme.palette.type === 'dark' ? '#FFFFFF' : '#2f71d1'};
`

export default TextSecondary
